// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocationsWrapper_wrapper__1EhiQ","content":"LocationsWrapper_content__t4opg","footer":"LocationsWrapper_footer__2QB3O","avatars":"LocationsWrapper_avatars__1NSYY"};